import { render, staticRenderFns } from "./AStaffDetailAppAuth.vue?vue&type=template&id=781155e2&scoped=true"
import script from "./AStaffDetailAppAuth.vue?vue&type=script&lang=js"
export * from "./AStaffDetailAppAuth.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailAppAuth.vue?vue&type=style&index=0&id=781155e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781155e2",
  null
  
)

export default component.exports